import React, { memo } from "react";

export default memo(({ show, colorClass, message }) => {
  if (!show) {
    return null;
  }
  return <p className={`help ${colorClass}`}>{message}</p>;
});
